import React, { useState } from "react";
import styles from "./PanningAndObjectPlacement.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";
import { Button } from "@src/lms/jelly/extensions/ui";
import { BedChannelsModal } from "./modals/BedChannels";
import { ObjectsPanningModal } from "./modals/ObjectsPanning";

export const PanningAndObjectPlacement: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isObjectsPanningModalVisible, setIsObjectsPanningModalVisible] = useState(false);

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.panningAndObjectPlacementTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.panningAndObjectPlacementDescription) }}></p>
              <div className={styles.buttonContainer}>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsModalVisible(true)}
                  icon="cil-spreadsheet"
                >
                  {formatMessage(messages.panningAndObjectPlacementButton)}
                </Button>
              </div>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.panningAndObjectPlacementTitle)}</h3>
            <ui.Scrollbars>
              <p
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.panningAndObjectPlacementDescription2) }}
              ></p>
              <div className={styles.buttonContainer}>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsObjectsPanningModalVisible(true)}
                  icon="cil-spreadsheet"
                >
                  {formatMessage(messages.panningAndObjectPlacementButton)}
                </Button>
              </div>
            </ui.Scrollbars>
          </div>,
          <div key={3} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.panningAndObjectPlacementTitle)}</h3>
            <ui.Scrollbars>
              <p
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.panningAndObjectPlacementDescription3) }}
              ></p>
            </ui.Scrollbars>
          </div>,
          <div key={4} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.panningAndObjectPlacementTitle)}</h3>
            <ui.Scrollbars>
              <p
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.panningAndObjectPlacementDescription4) }}
              ></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
      <BedChannelsModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
      <ObjectsPanningModal
        visible={isObjectsPanningModalVisible}
        onClose={() => setIsObjectsPanningModalVisible(false)}
      />
    </div>
  );
};
